<div class="layout-topbar p-shadow-4">
    <div class="layout-topbar-left">
        <a class="layout-topbar-logo">
            <img id="app-logo" src="assets/pin_logo.svg" alt="PIN AG" style="width: 9rem">
        </a>

        <ng-container *ngIf="(applicationServiceExt.appMode !== 1)">
            <a class="layout-menu-button p-shadow-6" (click)="applicationServiceExt.onMenuButtonClick($event)">
                <i class="pi pi-chevron-right"></i>
            </a>

            <a class="layout-topbar-mobile-button" (click)="applicationServiceExt.onTopbarMobileButtonClick($event)">
                <i class="pi pi-ellipsis-v fs-large"></i>
            </a>
        </ng-container>

    </div>

    <div class="layout-topbar-right" [ngClass]="{'layout-topbar-mobile-active': applicationServiceExt.isMobileTopbarActive}">
        <div class="layout-topbar-actions-left">
            <div [ngClass]="((isLiveSystem === true) ? 'app-title-live' : 'app-title-test')">{{applicationServiceExt.headerCaption}}</div>
        </div>
        <div class="layout-topbar-actions-right">
            <ul class="layout-topbar-items">
                <p-dropdown class="mt-2 mr-4" [options]="currentUser.depots" [(ngModel)]="selectedDepot" optionLabel="name"></p-dropdown>

                <li *ngIf="(applicationServiceExt.appMode !== 1)" class="layout-topbar-item">
                    <a class="layout-topbar-action flex flex-row justify-content-center align-items-center px-2 rounded-circle" (click)="applicationServiceExt.onTopbarItemClick($event, 'profile')">
                        <i class="fa fa-2x fa-user" style="font-size: 2rem;"></i>
                        <!--<img src="assets/demo/images/avatar/amyelsner.png" alt="avatar" style="width: 32px; height: 32px;">-->
                    </a>

                    <ul class="layout-topbar-action-panel shadow-6" [@topbarActionPanelAnimation]="'visible'" *ngIf="applicationServiceExt.activeTopbarItem === 'profile'">
                        <li class="layout-topbar-action-item">
                            <span class="flex flex-column ml-2">
                                <span class="p-text-bold">{{userDisplayName}}</span>
                                <small>{{userRoleDescription}}</small>
                            </span>
                        </li>
                        <hr>
                        <li class="layout-topbar-action-item version-info">
                            <div class="flex flex-column ml-2">
                                <small class="version-label">Build: {{versionInfo?.buildTimestamp ? (versionInfo.buildTimestamp | date:'dd.MM.yyyy HH:mm') : 'N/A'}}</small>
                                <small class="version-label">Version: {{versionInfo?.version || 'N/A'}}</small>
                                <small class="version-label">Branch: {{versionInfo?.gitBranch || 'N/A'}}</small>
                                <small class="version-label">Hash: {{versionInfo?.gitHash ? versionInfo.gitHash.substring(0, 8) : 'N/A'}}</small>
                            </div>
                        </li>
                        <hr>
                        <!--<li class="layout-topbar-action-item">
                            <a class="flex flex flex-row align-items-center" (click)="editUserAsync()">
                                <i class="pi pi-cog mr-2"></i>
                                <span>Einstellungen</span>
                            </a>
                        </li>-->
                        <li class="layout-topbar-action-item">
                            <a class="flex flex-row align-items-center" (click)="logoutAsync()">
                                <i class="pi pi-power-off mr-2"></i>
                                <span>Abmelden</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!--<li class="layout-topbar-item">
                    <a class="layout-topbar-action rounded-circle" (click)="coreServicesAccessor.desktopService.onRightMenuButtonClick($event)">
                        <i class="pi fs-large pi-arrow-left"></i>
                    </a>
                </li>-->
                <!--<li class="layout-topbar-item">
                    <a class="layout-topbar-action rounded-circle" (click)="reloadDataAsync()">
                        <i [class]="'fa fa-2x fa-sync-alt' + (((isLoading$ | async) === true) ? ' pi-spin spinner-enabled' : '')"></i>
                    </a>
                </li>-->
                <li class="layout-topbar-item" style="background: silver;">
                    <a class="layout-topbar-action rounded-circle">
                        <i [ngClass]="networkItemClass"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
